import { render, staticRenderFns } from "./StockHistoryEdit.vue?vue&type=template&id=023bcba6&scoped=true&"
import script from "./StockHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./StockHistoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockHistoryEdit.vue?vue&type=style&index=0&id=023bcba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bcba6",
  null
  
)

export default component.exports